import { render, staticRenderFns } from "./previous-video-form.vue?vue&type=template&id=697a0994&"
import script from "./previous-video-form.vue?vue&type=script&lang=js&"
export * from "./previous-video-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports